import axios from 'axios';
import { API_BASE_URL } from './config';

axios.defaults.withCredentials = true;

// Add global interceptor for all axios instances
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only redirect if not already on login/register pages
      const currentPath = window.location.pathname;
      const isAuthPage = currentPath === '/login' ||
        currentPath === '/register' ||
        currentPath === '/' ||
        currentPath === '/forgot-password' ||
        currentPath.startsWith('/reset-password');

      if (!isAuthPage) {
        console.log('Token expiré ou non autorisé. Redirection vers la page de login...');
        // Clear localStorage
        localStorage.removeItem('user');
        localStorage.removeItem('userConfig');
        // Rediriger vers la page de login
        window.location.href = '/login';
      } else {
        console.log('401 error on auth page - no redirect needed');
      }
    }
    return Promise.reject(error);
  }
);

const API_URL = API_BASE_URL;
export const api = axios.create({
  baseURL: API_URL
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const isAuthPage =
        currentPath === '/login' ||
        currentPath === '/register' ||
        currentPath === '/' ||
        currentPath === '/forgot-password' ||
        currentPath.startsWith('/reset-password');

      if (!isAuthPage) {
        console.log('Token expiré ou non autorisé. Redirection vers la page de login...');
        localStorage.removeItem('user');
        localStorage.removeItem('userConfig');
        window.location.href = '/login';
      } else {
        console.log('401 error on auth page - no redirect needed');
      }
    }
    return Promise.reject(error);
  }
);

// Configure axios to send cookies with every request
// api.defaults.withCredentials = true; // This line is now redundant as it's set globally

// Register a new user
export const register = async (username, email, password, first_name, last_name, phone, plan) => {
  try {
    const response = await api.post('/auth/register', {
      username,
      email,
      password,
      first_name,
      last_name,
      phone,
      plan
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Registration failed');
  }
};

// Login user. The token will be set in an HttpOnly cookie by the server.
export const login = async (username, password) => {
  try {
    console.log('Tentative de connexion pour:', username);

    const response = await api.post('/auth/login/json', {
      username,
      password
    });

    console.log('Réponse du serveur:', response.data);

    if (response.data.success && response.data.user) {
      // The token is in an HttpOnly cookie. We just save the non-sensitive user info.
      // Ne jamais stocker les paramètres sensibles (comme les identifiants Mautic) dans le localStorage.
      // Nous les retirons de l'objet avant de le sauvegarder.
      // On retire manuellement TOUS les champs sensibles avant de stocker.
      const {
        mautic_url,
        mautic_username,
        mautic_password,
        parameters, // Au cas où la structure changerait
        ...userToStore
      } = response.data.user;

      // Include subscription and modules in stored user data
      userToStore.subscription = response.data.user.subscription || null;
      userToStore.modules = response.data.user.modules || [];

      localStorage.setItem('user', JSON.stringify(userToStore));

      // Save specific config data separately for easier access
      const userConfig = {
        brand: response.data.user.brand,
      };
      localStorage.setItem('userConfig', JSON.stringify(userConfig));
    } else {
      console.error('La connexion a échoué ou les données utilisateur sont manquantes.');
    }

    return response.data;
  } catch (error) {
    console.error('Erreur de connexion:', error.response?.data || error);
    throw new Error(error.response?.data?.detail || 'Login failed');
  }
};

// Logout user
export const logout = () => {
  // We can't remove the HttpOnly cookie from JS.
  // We could create a '/logout' endpoint on the backend to clear it.
  // For now, just clearing localStorage is enough to log the user out of the UI.
  localStorage.removeItem('user');
  localStorage.removeItem('userConfig');
  console.log('Utilisateur déconnecté côté client.');
};

// Get current user from localStorage
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      console.error("Could not parse user from localStorage", e);
      return null;
    }
  }
  return null;
};

// The authHeader is no longer needed for calls to our backend,
// as the browser will send the HttpOnly cookie automatically.
export const authHeader = () => {
  return {};
};

// The request interceptor for token refresh is no longer needed.
// The browser and server handle the cookie's lifecycle.

// Note: Response interceptor for 401 errors is already set up globally above
// No need to duplicate it here for the api instance

export default api;
